import { Injectable } from '@angular/core';
import { Command } from 'flux-core';
import { ShapeModel } from '../../../base/shape/model/shape.mdl';
import { AbstractDiagramChangeCommand } from './abstract-diagram-change-command.cmd';
import { DiagramChangeService } from '../../../base/diagram/diagram-change.svc';
import { ShapeBoundsLocator } from '../containers/shape-bounds-locator';

/**
 * GetShapeContainer
 * This command will return containers ids of given shapes
 *
 *  data: {
 *      shapeIds: string[],
 *  }
 *
 *  resultData: {
 *      [shapeId: string]: string,
 *  }
 *
 */
@Injectable()
@Command()
export class GetShapeContainer extends AbstractDiagramChangeCommand  {

    public data: {
        shapeIds: string[],
    };

    public constructor( protected ds: DiagramChangeService, protected sbl: ShapeBoundsLocator ) {
        super( ds );
    }

    /**
     * Get parent ids for each shape
     */
    public prepareData() {
        this.resultData = {};
        for ( const shapeId of this.data.shapeIds ) {
            const shape = this.changeModel.shapes[shapeId] as ShapeModel;
            if ( shape.type === 'connector' ) {
                continue;
            }
            const container = this.changeModel.getParentOfShape( shape.id, this.sbl );
            if ( container ) {
                this.resultData[ shapeId ] = container.id;
            }
        }
    }
}

Object.defineProperty( GetShapeContainer, 'name', {
    value: 'GetShapeContainer',
});
